import { render, staticRenderFns } from "./AllocationGraph.vue?vue&type=template&id=c9bd5356&lang=pug"
import script from "./AllocationGraph.vue?vue&type=script&lang=js"
export * from "./AllocationGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports